module.exports = __webpack_public_path__ + "rotary.svg?7bef3b9d274f5678b3b2f1c158939bb1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/rotary.svg
// module id = 207
// module chunks = 0